import { SlideOverHeader } from '@/components/slideOvers_v2';
import { DataSourceIcon } from '@/lib';
import { FC } from 'react';

interface IDataSourceTypePanelHeaderProps {
  id: string;
  title?: string;
}

const DataSourceTypePanelHeaderV2: FC<IDataSourceTypePanelHeaderProps> = ({ title, id }) => {
  return <SlideOverHeader icon={<DataSourceIcon type={id} className='size-16' />} title={title} />;
};

export default DataSourceTypePanelHeaderV2;
